import { render, staticRenderFns } from "./ExhibitorForm.vue?vue&type=template&id=47066a74"
import script from "./ExhibitorForm.vue?vue&type=script&lang=ts"
export * from "./ExhibitorForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports